import React, { useState, useEffect, Fragment, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Row, Card, Col, Label, Input, Table } from "reactstrap";
import Flatpickr from "react-flatpickr";
import { useFormik } from "formik";
import Select from "react-select";
import { createSelector } from "reselect";
import * as Yup from "yup";
import { chunk } from "lodash";
import "flatpickr/dist/themes/material_blue.css";
import { RouteStopsMount } from "../../../assets/images/icons/CustomIcons.jsx";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import AlertError from "../../../components/Alerts/AlertError";
import i18n from "../../../i18n";
import config from "../../../constants/settings";
import { BookingType, VisibilityTypes, TypeAddress, EmployeeStatus } from "../../../constants/enums";
import { orgId, isPartnerAllowed } from "../../../constants/utils";
import {
  getOrgsAdmin as onGetOrgsAdmin,
  getProfile,
  getEmployeesAdmin,
  postEmployeesAdminCreateAddress,
  postServicesAdmin,
  getServiceRequestAdmin,
  getCostCentersAdmin,
  getRoutes,
  getRouteStops
} from "../../../helpers/api_rombo_helper";
import PlacesServices from "../../Google/PlacesServices";
import MapServices from "../../Google/MapServices";

const RouteRequestService = (props) => {
  document.title = `${i18n.t("ServiceRequest")} - ${orgId}`;

  const dispatch = useDispatch();
  const history = useNavigate();
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [listCompanies, setListCompanies] = useState([]);
  const [costCenters, setCostCenters] = useState({});
  const [findCostCenters, setFindCostCenters] = useState([]);
  const [listCostCenters, setListCostCenters] = useState([]);
  const [minTime, setMinTime] = useState("");
  const [key, setKey] = useState(0);
  const [listTypeService, setListTypeService] = useState([]);
  const [company, setCompany] = useState({});
  const [costCenter, setCostcenter] = useState({});
  const [typeService, setTypeService] = useState({ label: i18n.t("TextService2"), value: BookingType.CLOSED });
  const [showCostCenter, setShowCostCenter] = useState(true);
  const [showSelectedRoute, setShowSelectedRoute] = useState(false);
  const [showGeneral, setShowGeneral] = useState(false);
  const [showDateHour, setShowDateHour] = useState(false);
  const [showTypeService, setShowTypeService] = useState(false);
  const [showAdditionalNote, setShowAdditionalNote] = useState(false);
  const [showAddresses, setShowAddresses] = useState(false);
  const [showUnits, setShowUnits] = useState(false);
  const [showIdTag, setShowIdTag] = useState(false);
  const [showPassengers, setShowPassengers] = useState(false);
  const [showEmployees, setShowEmployees] = useState(false);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showScales, setShowScales] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [onFocusAddress, setOnFocusAddress] = useState("");
  const [newCreateAddressEmployee, setNewCreateAddressEmployee] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [formatEmployees, setFormatEmployees] = useState([]);
  const [arrScales, setArrScales] = useState([{ id: 3, latLon: false, typeAddress: TypeAddress.ARRAY_SCALES, dragg: false, editRow: false, onDrag: false, passenger_id: null, name: null, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);
  const [opts, setOpts] = useState({});
  const [aditionalNote, setAditionalNote] = useState("");
  const [idTag, setIdTag] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showNextBlock, setShowNextBlock] = useState(false);
  const [disableTextarea, setDisableTextarea] = useState(false);
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestiny, setSelectedDestiny] = useState(null);
  const [originAddressService, setOriginAddressService] = useState({});
  const [destinyAddressService, setDestinyAddressService] = useState({});
  const [addressesMarkers, setAddressesMarkers] = useState([]);
  const [units, setUnits] = useState(1);
  const [titleAdressDestiny, setNameTitleDestiny] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Destiny"), address: "" }));
  const [titleAdressOrigin, setNameTitleOrigin] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Origin"), address: "" }));
  const [titleAdressArrScales, setNameTitleArrScales] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Employee"), address: "" }));
  const [titleAdressArrEmployees, setNameTitleEmployees] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Scale"), address: "" }));
  const [employees, setEmployees] = useState([]);
  const [employeesSelectedFind, setEmployeesSelectedFind] = useState([]);
  const [employeesSelected, setEmployeesSelected] = useState([]);
  const [findEmployees, setFindEmployees] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [serviceCode, setServiceCode] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [currentService, setCurrentService] = useState(null);
  const [userProfile, setUserProfile] = useState({ username: '', sub: '' });
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [routeStops, setRouteStops] = useState([]);
  const [isLoadingStops, setIsLoadingStops] = useState(false);
  const [isRemovingStop, setIsRemovingStop] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAddingStop, setIsAddingStop] = useState(false);
  const [showAdditionalStop, setShowAdditionalStop] = useState(false);
  const [passengers, setPassengers] = useState(1);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [errors, setErrors] = useState({
    origin: false,
    destiny: false,
    costcenter: false,
    date: false,
    hour: false,
    typeService: false,
  });

  const [dateService, setDateService] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  });

  const [hourService, setHourService] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 25);
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  });

  const [newStopAddress, setNewStopAddress] = useState({
    id: "additional-stop",
    description: "",
    location: null,
    typeAddress: TypeAddress.ARRAY_SCALES
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
      userProfile: Login.userProfile
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  const setError = (field, value) => {
    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: value,
    }));
  };

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: "",
      identifier: "",
      depot: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string(),
      identifier: Yup.string(),
      depot: Yup.string()
    })
  });

  useEffect(() => {
    fillTypeService()
    getMinutes()
    infoUser.is_staff ? getCompanies() : fillCompany();
  }, [dispatch, infoUser]);
  
  useEffect(() => {
    if (company?.value !== undefined) {
      onGetEmployeesAdmin();
    }
  }, [dispatch, company]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    fEmployee();
  }, [employeesSelected]);

  useEffect(() => {
    if (editingEmployee?.addresses?.length > 0) {
      setSelectedAddress(editingEmployee.addresses[0].id);
    }
  }, [editingEmployee]);

  useEffect(() => {
    const now = new Date();
    const today = new Date();
  
    const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    
    if (dateService === todayStr) {
      now.setMinutes(now.getMinutes() + 25);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      
      setMinTime(minTimeFormatted);
  
      const [currentHour, currentMinute] = hourService.split(':').map(Number);
      const minTimeInMinutes = parseInt(minHours) * 60 + parseInt(minMinutes);
      const currentTimeInMinutes = currentHour * 60 + currentMinute;
      
      if (currentTimeInMinutes < minTimeInMinutes) {
        setHourService(minTimeFormatted);
      }
    } else {
      setMinTime("");
    }
  }, [dateService, hourService]);  

  useEffect(() => {
    fillTypeService();
  }, []);
  
  useEffect(() => {
    fillTypeService();
    setTypeService(prev => ({
      ...prev,
      label: i18n.t("TextService2")
    }));
  }, [i18n]);

  useEffect(() => {
    validateAddresses();
  }, [originAddressService.description, destinyAddressService.description, typeService.value]);

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);  

  useEffect(() => {
    if (company?.value) {
      setErrors(prev => ({ ...prev, company: false }));
    }
  }, [company]);

  useEffect(() => {
    if (token) {
      getProfile(token)
        .then((response) => {
          setUserProfile({
            username: response.full_name || '',
            sub: response.id || ''
          });
        })
        .catch((error) => {
          console.error("Error getting user profile:", error);
        });
    }
  }, [token]);

  const fEmployee = () => {
    let arr = []
    employeesSelected.map((item) => {
      arr.push({ label: item.name, value: item.idEmployee })
    })
    setFormatEmployees([...arr])
  }

  const getMinutes = (selectedDate) => {
    const minTimeSlots = parseInt(config.services.timeSlots, 10) + 5;
    const now = new Date();
    const date = new Date(selectedDate);
  
    if (isNaN(date.getTime())) {
      console.error('Fecha seleccionada inválida');
      return;
    }
  
    const isToday = now.toDateString() === date.toDateString();
  
    if (isToday) {
      now.setMinutes(now.getMinutes() + minTimeSlots);
      const minHours = now.getHours().toString().padStart(2, '0');
      const minMinutes = now.getMinutes().toString().padStart(2, '0');
      const minTimeFormatted = `${minHours}:${minMinutes}`;
      setMinTime(minTimeFormatted);
      setHourService(minTimeFormatted);
    } else {
      setMinTime("00:00");
      setHourService("00:00");
    }
  };  

  useEffect(() => {
    if(!newCreateAddressEmployee.idDB) return;

    let body = { addresses: [{ name: "Default", address: { ...newCreateAddressEmployee } }]}
    postEmployeesAdminCreateAddress(token, newCreateAddressEmployee.idDB, body)
      .then((responseAddress) => {
        onGetEmployeesAdmin()
      })
      .catch((error) => { 
        console.error("Error - postEmployeesAdminCreateAddress - ", error)
        if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
      })  
    
  }, [newCreateAddressEmployee]);

  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchServiceRequest(id);
    }
  }, [id]);

  useEffect(() => {
    if (isEditMode) {
      setShowNextBlock(true);
    }
  }, [isEditMode]);
  
  useEffect(() => {
    if (showEmployees && isEditMode && company.value) {
      const initialOpts = { 
        partner_id: company.value, 
        size: 5, 
        status: EmployeeStatus.ACTIVE,
        page: 1
      };
      onGetEmployeesAdmin(initialOpts);
      
      if (employeesSelectedFind.length > 0) {
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        setFindEmployees(prev => prev.filter(emp => !selectedIds.includes(emp.id)));
      }
    }
  }, [showEmployees, isEditMode, company.value, employeesSelectedFind]);
  
  const fetchServiceRequest = async (requestId) => {
    try {
      const response = await getServiceRequestAdmin(token, requestId);
      const data = response || {};
      setCurrentService(data);
  
      setTypeService({
        label:
          data.type === BookingType.OPEN
            ? i18n.t("TextService1")
            : data.type === BookingType.CLOSED
            ? i18n.t("TextService2")
            : data.type || "N/A",
        value: data.type || "",
      });
      setCompany({ label: data.partner_name || "N/A", value: data.partner_id || "" });
      setDateService(data.scheduled_start?.date || "");
      setHourService(data.scheduled_start?.time || "");
      setAditionalNote(data.info?.notes?.[0]?.message || "");
      setIdTag(data.info?.cost_center?.name || "");
  
      const markers = [];
  
      const normalizeLocation = (latlng) => {
        return {
          lat: Number(latlng.latitude),
          lng: Number(latlng.longitude ?? latlng.lon ?? latlng.lng),
        };
      };
  
      const origin = data.info?.origin?.address;
      if (origin) {
        const originData = {
          id: TypeAddress.ORIGIN,
          description: origin.description,
          location: normalizeLocation(origin.latlng),
          typeAddress: TypeAddress.ORIGIN,
          dragg: true,
        };
        setOriginAddressService(originData);
        setSelectedOrigin(originData.location);
        markers.push(originData);
      }
  
      const destination = data.info?.destination?.address;
      if (destination) {
        const destinationData = {
          id: TypeAddress.DESTINY,
          description: destination.description,
          location: normalizeLocation(destination.latlng),
          typeAddress: TypeAddress.DESTINY,
          dragg: true,
        };
        setDestinyAddressService(destinationData);
        setSelectedDestiny(destinationData.location);
        markers.push(destinationData);
      }
  
      const scales = data.info?.scales || [];
      const formattedScales = scales.map((scale, index) => ({
        id: index + 1,
        description: scale.address.description,
        location: normalizeLocation(scale.address.latlng),
        typeAddress: TypeAddress.ARRAY_SCALES,
        dragg: true,
        order: scale.order || index + 1,
      }));
      setArrScales(formattedScales);
      markers.push(...formattedScales);
  
      const riders = data.info?.riders || [];
      const formattedEmployees = riders.map((rider) => {
        const employeeInfo = findEmployees.find((emp) => emp.id === rider.id) || {};
  
        return {
          idEmployee: rider.id,
          id: rider.id,
          name: rider.name,
          identifier: employeeInfo.identifier || "N/A",
          depot: employeeInfo.depot || "N/A",
          addresses: employeeInfo.addresses || [],
          available_trips: employeeInfo.available_trips || 0,
          cost_center: employeeInfo.cost_center || { name: "N/A" },
          dropoff: rider.dropoff,
          address: employeeInfo.addresses?.[0] || {},
          is_individual_trip: false,
        };
      });
  
      setEmployeesSelectedFind(formattedEmployees);
      setEmployeesSelected(formattedEmployees);
      setAddressesMarkers(markers);
  
      if (riders.length > 0) {
        const employeeIds = riders.map((r) => r.id);
        getEmployeesAdmin(token, { ids: employeeIds.join(",") })
          .then((response) => {
            setFindEmployees(response.items);
          })
          .catch((error) => {
            console.error("Error fetching employees details:", error);
          });
      }
  
      riders.forEach((rider) => {
        if (!rider.dropoff.destination) {
          const scaleIndex = rider.dropoff.scale_order - 1;
          if (scaleIndex >= 0 && scaleIndex < formattedScales.length) {
            formattedScales[scaleIndex].employeeId = rider.id;
            formattedScales[scaleIndex].employeeName = rider.name;
          }
        }
      });
    } catch (error) {
      console.error("Error getting service request:", error);
      setErrorAlert(true);
      setErrorAlertMessage(error?.response?.data?.detail || error.message);
    }
  };

  const onClickCreateRequest = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    
    if (!typeService.value) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    setIsSubmitting(true);
  
    if ((!originAddressService?.location && typeService.value !== BookingType.ARRIVAL) || 
        (!destinyAddressService?.location && typeService.value === BookingType.CLOSED)) {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
      return;
    }
  
    try {
      for (let unitIndex = 0; unitIndex < units; unitIndex++) {
        const unitEmployees = groupedEmployees[unitIndex] || [];
  
        const arr = [];
        let scaleCounter = 1;
  
        unitEmployees.forEach((item) => {
          let body = {
            id: item.idEmployee,
            name: item.name,
            cost_center_id: item.cost_center_id ?? "N/A",
            cost_center_name: item.cost_center_name ?? "N/A",
            dropoff: {
              destination: true,
              scale_order: 0,
            },
          };
  
          if (selectedRoute && routeStops.length > 0) {
            const sortedStops = [...routeStops].sort((a, b) => a.order - b.order);
            
            const employeeStopIndex = sortedStops.findIndex(stop => 
              stop.employeeId === item.idEmployee || stop.passenger_id === item.idEmployee
            );
            
            if (employeeStopIndex !== -1) {
              body.dropoff.destination = false;
              body.dropoff.scale_order = employeeStopIndex + 1;
            }
          } else {
            arrScales.forEach((scale) => {
              if (scale.location && item.idEmployee === (scale.employeeId || scale.passenger_id)) {
                body.dropoff.destination = false;
                body.dropoff.scale_order = scaleCounter;
                scaleCounter++;
              }
            });
          }
  
          if (typeService.value !== BookingType.CLOSED && typeService.value !== BookingType.OPEN) {
            body.is_individual_trip = item.is_individual_trip;
            body.address = {
              description: item.address.address.description,
              latlng: {
                latitude: item.address.address.location.lat,
                longitude: item.address.address.location.lon,
              },
            };
          }
          arr.push(body);
        });
  
        let formData = bodyGral();
        formData.info.riders = arr;
        formData.type = typeService.value;
        formData.info.unit_number = unitIndex + 1;
  
        if (selectedRoute) {
          formData.info.route_id = selectedRoute.id;
          formData.info.route_name = selectedRoute.name;
          
          if (routeStops.length > 0) {
            const sortedStops = [...routeStops].sort((a, b) => a.order - b.order);
            formData.info.stops = sortedStops.map(stop => ({
              id: stop.id,
              order: stop.order,
              name: stop.name,
              address: stop.address,
              latitude: stop.latitude,
              longitude: stop.longitude,
              notes: stop.notes
            }));
          }
        }
  
        switch (typeService.value) {
          case BookingType.OPEN:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;
  
          case BookingType.CLOSED:
            if (selectedRoute && routeStops.length > 0) {
              const sortedStops = [...routeStops].sort((a, b) => a.order - b.order);
              
              const scaleStops = sortedStops.slice(1, -1);
              
              formData.info.scales = scaleStops.map((stop, index) => ({
                order: stop.order,
                address: {
                  description: stop.address || stop.name,
                  latlng: {
                    latitude: stop.latitude,
                    longitude: stop.longitude,
                  },
                },
              }));
  
              if (sortedStops[0]) {
                formData.info.origin = {
                  address: {
                    description: sortedStops[0].address || sortedStops[0].name,
                    latlng: {
                      latitude: sortedStops[0].latitude,
                      longitude: sortedStops[0].longitude,
                    },
                  },
                };
              }
  
              if (sortedStops[sortedStops.length - 1]) {
                formData.info.destination = {
                  address: {
                    description: sortedStops[sortedStops.length - 1].address || sortedStops[sortedStops.length - 1].name,
                    latlng: {
                      latitude: sortedStops[sortedStops.length - 1].latitude,
                      longitude: sortedStops[sortedStops.length - 1].longitude,
                    },
                  },
                };
              }
            } else {
              const onArrScales = arrScales
                .filter(scale =>
                  scale.location &&
                  (unitEmployees.some(e => e.idEmployee === (scale.employeeId || scale.passenger_id)) || !scale.employeeId)
                )
                .map((scale, index) => ({
                  order: index + 1,
                  address: {
                    description: scale.description,
                    latlng: {
                      latitude: scale.location.lat,
                      longitude: scale.location.lon || scale.location.lng,
                    },
                  },
                }));
              formData.info.scales = onArrScales;
              formData.info.origin = {
                address: {
                  description: originAddressService.description,
                  latlng: {
                    latitude: originAddressService.location.lat,
                    longitude: originAddressService.location.lon,
                  },
                },
              };
              formData.info.destination = {
                address: {
                  description: destinyAddressService.description,
                  latlng: {
                    latitude: destinyAddressService.location.lat,
                    longitude: destinyAddressService.location.lon || destinyAddressService.location.lng,
                  },
                },
              };
            }
            break;
  
          case BookingType.ARRIVAL:
            formData.info.destination = {
              address: {
                description: destinyAddressService.description.toString(),
                latlng: {
                  latitude: destinyAddressService.location.lat,
                  longitude: destinyAddressService.location.lon,
                },
              },
            };
            break;
  
          case BookingType.LEAVING:
            formData.info.origin = {
              address: {
                description: originAddressService.description.toString(),
                latlng: {
                  latitude: originAddressService.location.lat,
                  longitude: originAddressService.location.lon,
                },
              },
            };
            break;
        }
        
        if (formData.info.stops) {
          formData.info.stops.forEach((stop, index) => {
          });
        }
  
        await serviceCreate(formData);
      }
      
    } catch (error) {
      console.error("Error creating requests:", error);
      setErrorAlertMessage(i18n.t("InvalidServiceType"));
      setErrorAlert(true);
    } finally {
      setIsSubmitting(false);
      isSubmittingRef.current = false;
    }
  };

  const bodyGral = () => {
    const body = {
      company_id: "5111",
      scheduled_start: {
        timezone: "America/Mexico_City",
        date: dateService,
        time: hourService,
      },
      info: {},
    };
    if (selectedRoute) {
      body.info.route_id = selectedRoute.id;
      body.info.route_name = selectedRoute.name;
      
      if (routeStops.length > 0) {
        const sortedStops = [...routeStops].sort((a, b) => a.order - b.order);
        body.info.stops_metadata = sortedStops.map(stop => ({
          id: stop.id,
          order: stop.order,
          name: stop.name,
          address: stop.address,
          latitude: stop.latitude,
          longitude: stop.longitude
        }));
      }
    }
    
    if (aditionalNote) {
      body.info.notes = [{ message: aditionalNote }];
    }
  
    if (!disableTextarea && idTag.trim() !== "") {
      body.info.cost_center = {
        id: "",
        name: idTag.trim(),
      };
    }
  
    if (filteredEmployees.length > 0) {
      const requester = filteredEmployees[0];
      body.info.requested_by = {
        id: requester.id,
        name: requester.name,
      };
    }
  
    if (userProfile.username && userProfile.sub) {
      body.info.action_by = {
        id: userProfile.sub,
        name: userProfile.username,
      };
    }
  
    return body;
  };

  const onGetEmployeesAdmin = (newOpts = { page: 1, service: true, size: 5, partner_id: company.value, status: EmployeeStatus.ACTIVE }) => {
    setLoading(true);
    getEmployeesAdmin(token, newOpts)
      .then((response) => {
        setOpts(newOpts);
        setEmployees(response);
        
        const selectedIds = employeesSelectedFind.map(e => e.idEmployee);
        const filteredItems = response.items.filter(emp => !selectedIds.includes(emp.id));
        
        setFindEmployees(filteredItems);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getEmployeesAdmin - ", error);
        setLoading(false);
      });
  };

  const getCompanies = () => {
    let arr = []
    onGetOrgsAdmin()
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const groupedEmployees = chunk(employeesSelectedFind, 4);
  
  const onChangeTypeService = (e) => {
    setShowTypeService(false);
    setShowAddresses(true);
    setTypeService(e);
    setOriginAddressService({});
    setDestinyAddressService({});
    setUnits(1);
    setAddressesMarkers([]);
    setError('typeService', false);
  };

  const handleValidateTypeService = () => {
    if (!typeService.value) {
      setError('typeService', true);
    }
  };
  
  const onBlurUnits = (val) => {
    setUnits(val)
  };

  const fillCompany = () => {
    setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
  };
  
  const fillTypeService = () => {
    const defaultService = {
      label: i18n.t("TextService2"),
      value: BookingType.CLOSED
    };
    
    let arr = [
      { label: i18n.t("TextService1"), value: BookingType.OPEN },
      defaultService,
      // { label: i18n.t("TextService3"), value: BookingType.ARRIVAL },
      // { label: i18n.t("TextService4"), value: BookingType.LEAVING },
    ];
    
    setListTypeService([...arr]);
    
    if (!typeService.value) {
      setTypeService(defaultService);
    }
  };

  const onChangeDate = (e) => {
    const selectedDate = e[0];
    if (selectedDate) {
      setDateService(`${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`);
      setError('date', false);
    } else {
      setError('date', true);
    }
  };
  
  const onChangeHour = (e) => {
    const selectedHour = e[0];
    if (selectedHour) {
      setHourService(`${selectedHour.getHours().toString().padStart(2, '0')}:${selectedHour.getMinutes().toString().padStart(2, '0')}`);
      setError('hour', false);
    } else {
      setError('hour', true);
    }
  };

  const onBlurAdditionalNote = (val) => {
    setShowDateHour(false)
    setShowTypeService(false)
    setAditionalNote(val)
  };

  const dropDownHidde = (val, type) => {
    setShowCostCenter(type === VisibilityTypes.COST_CENTER ? true : false)
    setShowSelectedRoute(type === VisibilityTypes.SELECTED_ROUTE ? true : false)
    setShowGeneral(type === VisibilityTypes.GENERAL ? true : false)
    setShowDateHour(type === VisibilityTypes.DATE_HOUR ? true : false)
    setShowAdditionalNote(type === VisibilityTypes.ADDITIONAL_NOTE ? true : false)
    setShowTypeService(type === VisibilityTypes.TYPE_SERVICE ? true : false)
    setShowAddresses(type === VisibilityTypes.ADDRESSES ? true : false)
    setShowUnits(type === VisibilityTypes.UNITS ? true : false)
    setShowIdTag(type === VisibilityTypes.IDTAG ? true: false)
    setShowEmployees(type === VisibilityTypes.EMPLOYEES ? true : false)
    setShowScales(type === VisibilityTypes.SCALES ? true : false)
    setShowPassengers(type === VisibilityTypes.PASSENGERS ? true : false)
  };
  
  const validateAddresses = useCallback(() => {
    setErrors(prev => ({
      ...prev,
      origin: typeService.value !== BookingType.ARRIVAL && !originAddressService.description,
      destiny: typeService.value === BookingType.CLOSED && !destinyAddressService.description
    }));
  }, [typeService.value, originAddressService.description, destinyAddressService.description]);

  const onGetRoutes = (params = {}) => {
    setLoading(true);
  
    const defaultParams = {
      token,
      partner_id: 5111,
      ...(costCenter.value && { cost_center_id: costCenter.value }),
      ...params,
    };
  
    getRoutes(defaultParams)
      .then((response) => {
        const routesData = Array.isArray(response) ? response : [];
        setRoutes(routesData);
        setFilteredRoutes(routesData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getRoutes - ", error?.response?.data || error.message);
        setLoading(false);
      });
  };
  
  useEffect(() => {
    if (costCenter.value) {
      onGetRoutes();
    }
  }, [costCenter.value]);
  
  const handleRouteSelect = async (route) => {
    setSelectedRoute(route);
    setSearchQuery(route.name);
    setShowDropdown(false);
    
    await loadRouteStops(route.id);
  
    if (routeStops.length > 0) {
      updateAddressesFromStops(routeStops);
    }
  };
  
  const fetchRoutes = async (costCenterId, page) => {
    setLoading(true);
    try {
      const response = await getRoutes({
        token,
        partner_id: 5111,
        cost_center_id: costCenterId,
        page,
      });
      const routesData = Array.isArray(response) ? response : [];
      setRoutes(routesData);
      setTotalPages(1);
      setCurrentPage(1);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching routes:", error);
      setLoading(false);
      setRoutes([]);
      setTotalPages(1);
      setCurrentPage(1);
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("ErrorFetchingRoutes"));
    }
  };
  
  useEffect(() => {
    if (costCenter.value) {
      fetchRoutes(costCenter.value, 1);
    } else {
      setRoutes([]);
      setTotalPages(1);
      setCurrentPage(1);
      setSelectedRoute(null);
    }
  }, [costCenter]);

  const serviceCreate = (formData) => {
    postServicesAdmin(token, formData)
      .then((response) => {
        if (response.code) {
          setServiceCode(response.code);
          setErrorAlert(false);
          localStorage.setItem("notify", "true");
          localStorage.setItem("headerText", i18n.t("SolicitedService"));
          localStorage.setItem(
            "bodyText",
            i18n.t("SuccessRequestServiceWithCode", {
              code: `<a href="/services/request/${response.code}">${response.code}</a>`,
            })
          );
  
          const redirectPath = infoUser?.is_staff
            ? "/services/general"
            : "/services/request";
  
          window.dispatchEvent(new Event("storage"));
          history(redirectPath);
        }
      })
      .catch((error) => {
        console.error("Error - postServicesAdmin ", error);
        setErrorAlert(true);
        setErrorAlertMessage(
          JSON.stringify(error?.response?.data?.detail || error.message)
        );
        if (error.code == 500) {
          setErrorAlertMessage(i18n.t("ServerError"));
        }
      });
  };

  const isDisabled = useMemo(() => {

    const hasNoOrigin = !originAddressService?.location;
    const hasNoDestiny = !destinyAddressService?.location;
    const shouldValidateIdTag = isPartnerAllowed(company.value || infoUser?.partner_id);
    const hasNoIdTag = shouldValidateIdTag && (!idTag || idTag.trim() === '');
  
    if (typeService.value === BookingType.OPEN) {
      return hasNoOrigin || hasNoIdTag;
    }
  
    return hasNoOrigin || hasNoDestiny || hasNoIdTag;
  }, [typeService.value, originAddressService?.location, destinyAddressService?.location, employeesSelectedFind, units, company.value, infoUser?.partner_id, idTag]);

  useEffect(() => {
    validateAddresses();
  }, [originAddressService, destinyAddressService, validateAddresses]);

  const onGetCostCentersAdmin = (newOpts = { page: 1, size: 12 }) => {
    if (token.Authorization) {
      const options = { ...newOpts, ...(5111 && { partner_id: 5111 }) };
      getCostCentersAdmin(token, options)
        .then((response) => {
          setOpts(options);
          setLoading(false);
          setCostCenters(response);
          setFindCostCenters(response.items);

          const formattedOptions = response.items.map((c) => ({
            value: c.id,
            label: c.name,
          }));
          setListCostCenters(formattedOptions);
        })
        .catch((error) => {
          console.error("Error - getCostCentersAdmin - ", error);
        });
    }
  };

  useEffect(() => {
    onGetCostCentersAdmin();
  }, []);

  const onChangeCostCenter = (e) => {
    setCostcenter(e);
    setErrors((prevErrors) => ({ ...prevErrors, costcenter: false }));
    dropDownHidde(true, VisibilityTypes.GENERAL);
  };

  const ROUTES_PER_PAGE = 5;
  const totalRoutesPages = Math.ceil((routes?.length || 0) / ROUTES_PER_PAGE);
  const startIndex = (currentPage - 1) * ROUTES_PER_PAGE;
  const paginatedRoutes = (routes || []).slice(startIndex, startIndex + ROUTES_PER_PAGE);

  const loadRouteStops = async (routeId) => {
    if (!routeId) return;
  
    setIsLoadingStops(true);
    try {
      const params = {
        token,
        partner_id: 5111,
        route_id: routeId,
      };
  
      const response = await getRouteStops(params);
      const stopsData = Array.isArray(response) ? response : [];
      
      const processedStops = stopsData.map(stop => ({
        id: stop.id,
        name: stop.name,
        order: stop.order,
        address: stop.address,
        latitude: stop.latitude,
        longitude: stop.longitude,
        notes: stop.notes,
        route_id: stop.route_id,
        partner_id: stop.partner_id,
        type: stop.type,
        active: stop.active,
        uuid: stop.uuid
      }));
  
      setRouteStops(processedStops);

      updateAddressesFromStops(processedStops);
      
    } catch (error) {
      console.error("Error loading route stops:", error);
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("ErrorLoadingStops"));
      setRouteStops([]);
    } finally {
      setIsLoadingStops(false);
    }
  };

  const handleRemoveStop = async (stopId) => {
    setIsRemovingStop(true);
    try {
      const filteredStops = routeStops.filter(stop => stop.id !== stopId);
      const updatedStops = filteredStops.map((stop, index) => ({
        ...stop,
        order: index + 1,
      }));
      setRouteStops(updatedStops);

      updateAddressesFromStops(updatedStops);
      
    } catch (error) {
      console.error("Error removing stop:", error);
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("ErrorRemovingStop"));
    } finally {
      setIsRemovingStop(false);
    }
  };

  const handleOnDragEnd = (result, items, setItems) => {
    if (!result.destination) return;
  
    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
  
    const updatedItems = newItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
  
    setItems(updatedItems);
    
    updateAddressesFromStops(updatedItems);
  };

  const updateAddressesFromStops = (stops) => {
    if (stops.length === 0) return;
  
    const sortedStops = [...stops].sort((a, b) => a.order - b.order);
  
    const originStop = sortedStops[0];
    if (originStop) {
      const originAddress = {
        id: TypeAddress.ORIGIN,
        description: originStop.address || originStop.name,
        location: {
          lat: originStop.latitude,
          lng: originStop.longitude,
        },
        typeAddress: TypeAddress.ORIGIN,
        dragg: true,
      };
      setOriginAddressService(originAddress);
      setSelectedOrigin(originAddress.location);
    }
  
    const destinationStop = sortedStops[sortedStops.length - 1];
    if (destinationStop && sortedStops.length > 1) {
      const destinationAddress = {
        id: TypeAddress.DESTINY,
        description: destinationStop.address || destinationStop.name,
        location: {
          lat: destinationStop.latitude,
          lng: destinationStop.longitude,
        },
        typeAddress: TypeAddress.DESTINY,
        dragg: true,
      };
      setDestinyAddressService(destinationAddress);
      setSelectedDestiny(destinationAddress.location);
    }
  
    const scaleStops = sortedStops.slice(1, -1);
    const formattedScales = scaleStops.map((stop, index) => ({
      id: stop.id || index + 1,
      description: stop.address || stop.name,
      location: {
        lat: stop.latitude,
        lng: stop.longitude,
      },
      typeAddress: TypeAddress.ARRAY_SCALES,
      dragg: true,
      order: stop.order,
      name: stop.name,
    }));
  
    setArrScales(formattedScales);
    updateMapMarkersFromStops(sortedStops);
  };

  const updateMapMarkersFromStops = (stops) => {
    const markers = [];
  
    stops.forEach((stop, index) => {
      let typeAddress;
      if (index === 0) {
        typeAddress = TypeAddress.ORIGIN;
      } else if (index === stops.length - 1) {
        typeAddress = TypeAddress.DESTINY;
      } else {
        typeAddress = TypeAddress.ARRAY_SCALES;
      }
  
      markers.push({
        id: `stop-${stop.id}`,
        description: stop.address || stop.name,
        location: {
          lat: stop.latitude,
          lng: stop.longitude,
        },
        typeAddress: typeAddress,
        dragg: false,
        order: stop.order,
        name: stop.name,
      });
    });
  
    setAddressesMarkers(markers);
  };

  const clearRouteAddressesAndMarkers = () => {
    setOriginAddressService({});
    setDestinyAddressService({});
    setArrScales([{ 
      id: 3, 
      latLon: false, 
      typeAddress: TypeAddress.ARRAY_SCALES, 
      dragg: false, 
      editRow: false, 
      onDrag: false, 
      passenger_id: null, 
      name: null, 
      address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } 
    }]);
    
    setAddressesMarkers([]);
    setSelectedOrigin(null);
    setSelectedDestiny(null);
    setRouteStops([]);
    setKey(prev => prev + 1);
  };

  const handleAddAdditionalStop = async () => {
    if (!newStopAddress?.description || !newStopAddress?.location) {
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("PleaseSelectValidAddress"));
      return;
    }
  
    setIsAddingStop(true);
    try {
      const newStop = {
        id: `temp-${Date.now()}`,
        name: newStopAddress.description,
        address: newStopAddress.description,
        latitude: newStopAddress.location.lat,
        longitude: newStopAddress.location.lon || newStopAddress.location.lng,
        order: routeStops.length + 1,
        type: "additional",
        notes: "",
        active: true
      };
  
      const updatedStops = [...routeStops, newStop];
      setRouteStops(updatedStops);
      
      updateAddressesFromStops(updatedStops);
      
      setNewStopAddress({
        id: "additional-stop",
        description: "",
        location: null,
        typeAddress: TypeAddress.ARRAY_SCALES
      });
      
      setKey(prev => prev + 1);
      
      setErrorAlert(false);
      
    } catch (error) {
      console.error("Error adding additional stop:", error);
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("ErrorAddingStop"));
    } finally {
      setIsAddingStop(false);
    }
  };

  const handleAddRowStop = () => {
    setShowAdditionalStop((prev) => !prev);
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("Services")} link='/services/request' breadcrumbItem={i18n.t("ServiceRequest")} />
          <div className="container-fluid">
            <Card>
              <Row className="p-3">
                <Col xxl={showEmployees ? 12 : 6} md={showEmployees ? 12 : 6} xs={12} className="">
                  {(!showEmployees) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showCostCenter, VisibilityTypes.COST_CENTER)} 
                      >
                        <h6 className="request-create-title">
                          { `${i18n.t("CostCenter")} ${costCenter.label ? `(${costCenter.label})` : ""} ` }
                          <i className={ `${showCostCenter ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">{i18n.t("SelectCostCenterService")}</p>
                      {showCostCenter && (
                        <Card className="custom-select-card">
                          <Select
                            name="costCenter"
                            placeholder={i18n.t("SelectCostCenter")}
                            value={listCostCenters.filter((c) => c.value == costCenter.value)}
                            options={listCostCenters}
                            className="select2-selection"
                            onChange={(e) => {
                              onChangeCostCenter(e);
                              dropDownHidde(true, VisibilityTypes.GENERAL);
                            }}
                            isDisabled={isEditMode}
                          />
                          {errors.costcenter && (
                            <span className="error-message">
                              <i className="fa fa-exclamation-circle" />
                              {i18n.t("CostCenterError")}
                            </span>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {(!isEditMode && !showEmployees) && <hr />}
                  {(!showEmployees && !isEditMode) && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => dropDownHidde(!showGeneral, VisibilityTypes.GENERAL)} 
                      >
                        <h6 className="request-create-title">
                          {i18n.t("Route")}
                          <i className={ `${showGeneral ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                        </h6>
                      </Link>
                      <p className="request-create-text modal-header-bottom" htmlFor="companyInput">{i18n.t("SelectRouteService")}</p>
                      {showGeneral && (
                        <Card className="custom-select-card">
                          <div className="table-responsive">
                            <Table className="table table-responsive mb-0">
                              <thead>
                                <tr>
                                  <th colSpan="4" className="bg-light border-0 p-3">
                                    <div className="d-flex justify-content-end align-items-center">
                                      <div className="search-wrapper me-0">
                                        <Input
                                          type="text"
                                          className="form-control search-input bg-white"
                                          placeholder={i18n.t("SearchRouteByName")}
                                          value={searchQuery}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setSearchQuery(value);
                                            if (value.trim() === "") {
                                              setFilteredRoutes(routes);
                                              setCurrentPage(1);
                                            } else {
                                              const filtered = routes.filter(route =>
                                                route.name?.toLowerCase().includes(value.toLowerCase())
                                              );
                                              setFilteredRoutes(filtered);
                                              setCurrentPage(1);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="bg-light">{i18n.t("RouteName")}</th>
                                  <th className="bg-light">{i18n.t("Shift")}</th>
                                  <th className="bg-light text-center">{i18n.t("Stops")}</th>
                                  <th className="bg-light text-center">{i18n.t("Action")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(selectedRoute ? [selectedRoute] : filteredRoutes.slice(startIndex, startIndex + ROUTES_PER_PAGE)).map((route, key) => (
                                  <tr key={key} className={selectedRoute?.id === route.id ? 'table-active' : ''}>
                                    <td>
                                      <strong>{route.name}</strong>
                                      <div className="text-muted small">
                                        {route.kms && `${route.kms} km`}
                                        {route.duration && ` • ${route.duration}`}
                                      </div>
                                    </td>
                                    <td className="align-middle">{route.partner_shift_name || i18n.t("NoShift")}</td>
                                    <td className="text-center align-middle">{route.stops}</td>
                                    <td className="text-center">
                                      <button 
                                        className={`btn btn-sm ${selectedRoute?.id === route.id ? 'btn-success' : 'btn-add-employees'}`}
                                        onClick={() => {
                                          handleRouteSelect(route);
                                          setShowNextBlock(true);
                                          setShowSelectedRoute(true);
                                          setShowDateHour(true);
                                          setShowPassengers(true);
                                          setShowAdditionalNote(true);
                                        }}
                                      >
                                        {selectedRoute?.id === route.id ? i18n.t("Selected") : i18n.t("Select")}
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                                {filteredRoutes.length === 0 && (
                                  <tr>
                                    <td colSpan="4" className="text-center py-4">
                                      <i className="bx bx-search-alt fs-1 text-muted mb-2 d-block" />
                                      <span className="text-muted">{i18n.t("NoRoutesFound")}</span>
                                      {searchQuery && (
                                        <div className="mt-2">
                                          <button 
                                            className="btn btn-link p-0"
                                            onClick={() => {
                                              setSearchQuery("");
                                              setFilteredRoutes(routes);
                                            }}
                                          >
                                            {i18n.t("ClearSearch")}
                                          </button>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                          {selectedRoute && (
                            <div className="text-start modal-header-bottom mt-3 px-3">
                              <button 
                                className="btn btn-link d-flex align-items-center"
                                style={{ color: "#495057" }}
                                onClick={() => {
                                  clearRouteAddressesAndMarkers();
                                  setSelectedRoute(null);
                                  setShowNextBlock(false);
                                  setCurrentPage(1);
                                  setSearchQuery("");
                                  setFilteredRoutes(routes);
                                }}
                              >
                                <i className="bx bx-revision me-2" />
                                <span style={{ textDecoration: "underline" }}>
                                  {i18n.t("ChangeRoute")}
                                </span>
                              </button>
                            </div>
                          )}            
                          {!selectedRoute && filteredRoutes.length > ROUTES_PER_PAGE && (
                            <div className="d-flex justify-content-end align-items-center mt-3 px-3">
                              <ul className="pagination pagination-rounded mb-0">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                  <button 
                                    className="page-link" 
                                    disabled={currentPage === 1} 
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                    aria-label="Previous"
                                  >
                                    <i className="mdi mdi-chevron-left"></i>
                                  </button>
                                </li>
                                {(() => {
                                  const totalFilteredPages = Math.ceil(filteredRoutes.length / ROUTES_PER_PAGE);
                                  const viewPaginations = 5;
                                  const startPage = Math.max(1, currentPage - Math.floor(viewPaginations / 2));
                                  const endPage = Math.min(totalFilteredPages, startPage + viewPaginations - 1);
                                  const pageNumbers = [];
                                  
                                  for (let i = startPage; i <= endPage; i++) {
                                    pageNumbers.push(i);
                                  }
                                  return pageNumbers.map((number) => (
                                    <li 
                                      key={number} 
                                      className={`page-item ${currentPage === number ? "active" : ""}`}
                                    >
                                      <button 
                                        className="page-link" 
                                        onClick={() => setCurrentPage(number)}
                                      >
                                        {number}
                                      </button>
                                    </li>
                                  ));
                                })()}
                                <li className={`page-item ${currentPage === Math.ceil(filteredRoutes.length / ROUTES_PER_PAGE) ? "disabled" : ""}`}>
                                  <button 
                                    className="page-link" 
                                    disabled={currentPage === Math.ceil(filteredRoutes.length / ROUTES_PER_PAGE)} 
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                    aria-label="Next"
                                  >
                                    <i className="mdi mdi-chevron-right" />
                                  </button>
                                </li>
                              </ul>
                            </div>
                          )}
                        </Card>
                      )}
                    </Col>
                  )}
                  {!showEmployees && (
                    <>
                      {showNextBlock && <hr />}
                      {showNextBlock && (
                        <>
                          <Col xxl={12} md={12} xs={12}>
                            <Link
                              className="request-create-title"
                              onClick={() => costCenter && dropDownHidde(!showSelectedRoute, VisibilityTypes.SELECTED_ROUTE)}
                            >
                              <h6 className="request-create-title modal-header-bottom">
                                {i18n.t("SelectedRoute")}
                                <i className={`${showSelectedRoute ? "fa fa-chevron-up" : "fa fa-chevron-down"} chevron-icon`} />
                              </h6>
                            </Link>
                            {showSelectedRoute && (
                              <Row>
                                <Col xxl={12} md={12} xs={12}>
                                  {selectedRoute && (
                                    <div className="mt-4">
                                      <div className="table-responsive pt-3">
                                        <DragDropContext onDragEnd={(result) => handleOnDragEnd(result, routeStops, setRouteStops)}>
                                          <Table className="table table-responsive">
                                            <thead>
                                              <tr>
                                                <th className="bg-light text-center">{i18n.t("Order")}</th>
                                                <th className="bg-light text-center">{i18n.t("Stop")}</th>
                                                <th className="bg-light">{i18n.t("Name")}</th>
                                                <th className="bg-light text-center">{i18n.t("Action")}</th>
                                              </tr>
                                            </thead>
                                            <Droppable droppableId="stops">
                                              {(provided) => (
                                                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                  {routeStops
                                                    .sort((a, b) => a.order - b.order)
                                                    .map((stop, index) => (
                                                      <Draggable key={stop.id} draggableId={stop.id.toString()} index={index}>
                                                        {(provided) => (
                                                          <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps} 
                                                          >
                                                            <td className="text-center align-middle">
                                                              <RouteStopsMount size={20} color="#ADB5BD" style={{ cursor: "grab" }} />
                                                            </td>                                                 
                                                            <td className="text-center align-middle">{stop.order}</td>
                                                            <td>
                                                              <strong>{stop.name}</strong>
                                                              {stop.address && (
                                                                <div className="text-muted small">{stop.address}</div>
                                                              )}
                                                            </td>
                                                            <td className="text-center">
                                                              <button
                                                                onClick={() => handleRemoveStop(stop.id)}
                                                                disabled={isRemovingStop}
                                                                className="btn p-0 border-0 bg-transparent text-danger"
                                                                title={i18n.t("Eliminated")}
                                                              >
                                                                <i className="mdi mdi-delete fs-5" />
                                                              </button>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </Draggable>
                                                    ))}
                                                  {provided.placeholder}
                                                </tbody>
                                              )}
                                            </Droppable>
                                          </Table>
                                        </DragDropContext>
                                        <Link
                                          className="add-scale-text"
                                          onClick={handleAddRowStop}
                                        >
                                          <i className="bx bx-plus add-scale-icon add-employee-icon" />
                                          {i18n.t("AddAdditionalStop")}
                                        </Link>
                                        {showAdditionalStop && (
                                          <div className="mt-4 p-3 border rounded bg-light">
                                            <Row className="align-items-end">
                                              <Col xxl={8} md={8} xs={12}>
                                                <PlacesServices
                                                  key={`additional-stop-${key}`}
                                                  selectedDestiny={selectedDestiny}
                                                  setAddressesMarkers={setAddressesMarkers}
                                                  selectedAddress={newStopAddress || { id: "additional-stop", description: "", location: null }}
                                                  addressesMarkers={addressesMarkers}
                                                  setSelectedAddress={(newAddress) => {
                                                    const validAddress = {
                                                      id: newAddress.id || "additional-stop",
                                                      description: newAddress.description || "",
                                                      location: newAddress.location || null,
                                                      typeAddress: TypeAddress.ARRAY_SCALES
                                                    };
                                                    setNewStopAddress(validAddress);
                                                  }}
                                                  typeAddress={TypeAddress.ARRAY_SCALES}
                                                  setSelectedDestiny={setSelectedDestiny}
                                                  rowsData={[]}
                                                  setRowsScale={() => {}}
                                                  rowsIndex={null}
                                                  titleAdressDestiny={titleAdressDestiny}
                                                  setNameTitleDestiny={setNameTitleDestiny}
                                                  titleAdressOrigin={titleAdressOrigin}
                                                  setNameTitleOrigin={setNameTitleOrigin}
                                                  setOnFocusAddress={setOnFocusAddress}
                                                  setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                                                  id="additional-stop-address"
                                                  companie={Number(company.value) || 0}
                                                  employeeAddresses={[]}
                                                  placeholder={i18n.t("EnterStopAddress")}
                                                />
                                              </Col>
                                              <Col xxl={4} md={4} xs={12} className="d-flex justify-content-end">
                                                <button
                                                  className="btn btn-add-employees"
                                                  onClick={handleAddAdditionalStop}
                                                  disabled={!newStopAddress?.description || isAddingStop}
                                                >
                                                  {isAddingStop ? i18n.t("Adding") : i18n.t("AddStop")}
                                                </button>  
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <hr />
                        </>
                      )}
                    </>
                  )}
                  {showNextBlock && (
                    <>
                      {!isEditMode && !showEmployees && (
                        <Col xxl={12} md={12} xs={12}>
                          <Link 
                            className="request-create-title"
                            onClick={() => costCenter && dropDownHidde(!showDateHour, VisibilityTypes.DATE_HOUR)}
                          >
                            <h6 className="request-create-title">
                              {`${i18n.t("DateHourService")} ${(dateService && hourService) ? `(${dateService} - ${hourService})` : ''}`}
                              <i className={ `${showDateHour ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                            </h6>
                          </Link>
                          <p className="request-create-text">{i18n.t("SelectDateHourService")}</p>
                          {showDateHour && (
                            <Row>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Date")}</Label>
                                  <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectDate")}
                                      value={dateService}
                                      onChange={(e) => onChangeDate(e)}
                                      options={{
                                        minDate: "today",
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        dateFormat: "Y-m-d",
                                        defaultDate: new Date()
                                      }}
                                    />
                                    <i className="mdi mdi-calendar-outline input-icon" />
                                  </div>
                                  {errors.date && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("DateError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                              <Col xxl={6} md={6} xs={12} className="pt-1">
                                <div className="form-group mb-3">
                                <Label>{i18n.t("Hour")}</Label>
                                <div className="custom-input">
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder={i18n.t("SelectHour")}
                                      value={hourService}
                                      onChange={(e) => onChangeHour(e)}
                                      options={{
                                        minDate: "today",
                                        minTime: minTime,
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "H:i",
                                        time_24hr: true,
                                        defaultDate: (() => {
                                          const now = new Date();
                                          now.setMinutes(now.getMinutes() + 25);
                                          return now;
                                        })(),
                                      }}
                                    />
                                  <i className="mdi mdi-clock-outline input-icon" />
                                </div>
                                  {errors.hour && (
                                    <span className="error-message">
                                      <i className="fa fa-exclamation-circle"></i>
                                      {i18n.t("HourError")}
                                    </span>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      )}
                      {!showEmployees && !isEditMode && ( 
                        <Col xxl={12} md={12} xs={12} style={{ display: 'none' }}>
                          <Link 
                            className="request-create-title"
                            onClick={() => (dateService && hourService) && dropDownHidde(!showTypeService, VisibilityTypes.TYPE_SERVICE)}
                          >
                            <h6 className="request-create-title">
                              { `${i18n.t("TypeService")} ${typeService.label ? `(${typeService.label})` : ""} ` }
                              <i className={ `${showTypeService ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                            </h6>
                          </Link>
                          <p className="request-create-text" htmlFor="companyInput">
                            {i18n.t("SelectTypeService")}
                          </p>
                          {showTypeService && (
                            <Card className="custom-select-card">
                              <Select
                                name="typeService"
                                placeholder={i18n.t("SelectTheTypeService")}
                                value={listTypeService.filter((c) => c.value == typeService.value)}
                                options={listTypeService}
                                className="select2-selection"
                                onChange={(e) => onChangeTypeService(e)}
                                onBlur={handleValidateTypeService}
                              />
                              {errors.typeService && (
                                <span className="error-message">
                                  <i className="fa fa-exclamation-circle"></i>
                                  {i18n.t("TypeServiceError")}
                                </span>
                              )}
                            </Card>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                  {!showEmployees && showNextBlock && (
                    <>
                      {showNextBlock && (<hr/>)}
                      <Col xxl={12} md={12} xs={12}>
                        <Link 
                          className="request-create-title"
                          onClick={() => (costCenter) && dropDownHidde(!showPassengers, VisibilityTypes.PASSENGERS)}
                        >
                          <h6 className="request-create-title">
                            {`${i18n.t("PassengersNumber")} ${ passengers ? `(${passengers})` : ''} `}
                            <i className={ `${showPassengers ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}` } />
                          </h6>
                        </Link>
                        <p className="request-create-text" htmlFor="companyInput">
                          {i18n.t("SelectPassengers")}
                        </p>
                        {showPassengers && (
                          <Row>
                            <Col xxl={2} md={2} xs={12}>
                              <div className="form-group mb-3">
                                <Input
                                  type="number"
                                  id="passengersInput"
                                  className="form-control units-input"
                                  value={passengers}
                                  onChange={(e) => {
                                    const value = parseInt(e.target.value) || 1;
                                    const limitedValue = Math.min(Math.max(value, 1), 13);
                                    setPassengers(limitedValue);
                                  }}
                                  placeholder={i18n.t("PassengersNumber")}
                                  min={1}
                                  max={13}
                                />
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                      {showNextBlock && (<hr/>)}
                    </>
                  )}
                  {!showEmployees && showNextBlock && (
                    <Col xxl={12} md={12} xs={12}>
                      <Link 
                        className="request-create-title"
                        onClick={() => (dateService && hourService) && dropDownHidde(!showAdditionalNote, VisibilityTypes.ADDITIONAL_NOTE)}
                      >
                        <h6 className="request-create-title">
                          {i18n.t("ReferenceNote")}
                          <i className={ `${showAdditionalNote ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} chevron-icon` } />
                        </h6>
                      </Link>
                      <p className="request-create-text" htmlFor="companyInput">
                        {i18n.t("DescAditionalNote")}
                      </p>
                      {showAdditionalNote && (
                        <Input
                          type="textarea"
                          defaultValue={aditionalNote}
                          placeholder={i18n.t("WriteYourNoteHere")}
                          onBlur={(e) => onBlurAdditionalNote(e.target.value)}
                        />
                      )}
                    </Col>
                  )}
                  {showNextBlock && (<hr/>)}
                </Col>
                {!showEmployees && (
                  <Col xxl={6} md={6} xs={12}>
                    <MapServices
                      key={key}
                      titleAdressArrScales={titleAdressArrScales}
                      titleAdressArrEmployees={titleAdressArrEmployees}
                      setNameTitleDestiny={setNameTitleDestiny}
                      titleAdressDestiny={titleAdressDestiny}
                      setNameTitleArrScales={setNameTitleArrScales}
                      setNameTitleEmployees={setNameTitleEmployees}
                      titleAdressOrigin={titleAdressOrigin}
                      setNameTitleOrigin={setNameTitleOrigin}
                      selectedDestiny={selectedDestiny}
                      selectedOrigin={selectedOrigin}
                      setShowUnits={setShowUnits}
                      setNewCreateAddressEmployee={setNewCreateAddressEmployee}
                      servicesView={true}
                      setShowAddresses={setShowAddresses}
                      showAddresses={showAddresses}
                      setAddressesMarkers={setAddressesMarkers}
                      addressesMarkers={addressesMarkers}
                      selectedAddress={destinyAddressService}
                      setFindEmployees={setFindEmployees}
                      findEmployees={findEmployees}
                      setShowEmployees={setShowEmployees}
                      typeService={typeService}
                      setArrScales={setArrScales}
                      arrScales={arrScales}
                      setSelectedAddress={setDestinyAddressService}
                      selectedAddressOrigin={originAddressService}
                      setSelectedAddressOrigin={setOriginAddressService}
                      selectedAddressDestiny={destinyAddressService}
                      setSelectedAddressDestiny={setDestinyAddressService}
                      typeAddress={onFocusAddress}
                      setOnFocusAddress={setOnFocusAddress}
                      setSelectedDestiny={setSelectedDestiny}
                      setSelectedOrigin={setSelectedOrigin}
                      disabled={false}
                    />
                  </Col>
                )}
                {!showEmployees && (
                  <Col xxl={12} xl={12} xs={12} className="pt-2 d-flex">
                    <button
                      onClick={() => (onClickCreateRequest())} 
                      className="btn btn-request"
                      disabled={isDisabled || isSubmitting}
                    >
                      {i18n.t("RequestService")}
                    </button>
                    <Link to={"/services/request"} className="btn btn-go-back mx-2">
                      {i18n.t("GoBack")}
                    </Link>
                  </Col>
                )}
              </Row>
            </Card>
          </div>
        </div>
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={i18n.t("ServiceAlertError")}
          textBody={errorAlertMessage}
        />
      </div>
    </Fragment>
  );
};

export default RouteRequestService;
